import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import arrow from 'images/three_d_studio/remesh/arrow.webp'
import initialTexture from 'images/three_d_studio/texture_tab/initial_texture.webp'
import newTexture from 'images/three_d_studio/texture_tab/new_texture.webp'

function Preview() {
  const t = useTranslation()

  return (
    <div className="texture-tab__preview" aria-hidden="true">
      <figure className="texture-tab__preview-item">
        <figcaption className="texture-tab__preview-label cgt-caption-semibold">
          {t('viewerSidebar.enhance.texture.preview.initial')}
        </figcaption>
        <img
          alt=""
          className="texture-tab__preview-image"
          src={initialTexture}
          width={112}
          height={112}
        />
      </figure>
      <span className="texture-tab__preview-arrow">
        <img className="texture-tab__preview-arrow-image" src={arrow} alt="" width={27} height={12} />
      </span>
      <figure className="texture-tab__preview-item">
        <figcaption className="texture-tab__preview-label cgt-caption-semibold">
          {t('viewerSidebar.enhance.texture.preview.new')}
        </figcaption>
        <img
          alt=""
          className="texture-tab__preview-image"
          src={newTexture}
          width={112}
          height={112}
        />
      </figure>
    </div>
  )
}

export default memo(Preview)
